import {
  Action,
  ActionType,
  DataStatisticsResponse,
} from "models/bodyTemperature/statistics";
import createReducer from "../../createReducer";

export interface DataStatisticsReducerType {
  loading: boolean;
  error?: string;
  dataStatisticsResponse?: DataStatisticsResponse;
}

const defaultState: DataStatisticsReducerType = {
  loading: false,
  error: undefined,
  dataStatisticsResponse: undefined,
};

export const dataStatisticsReducer = createReducer<DataStatisticsReducerType>(
  defaultState,
  {
    [ActionType.DATA_STATISTICS](state: DataStatisticsReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.DATA_STATISTICS_ERROR](
      state: DataStatisticsReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        dataStatisticsResponse: undefined,
      };
    },

    [ActionType.DATA_STATISTICS_SUCCESS](
      state: DataStatisticsReducerType,
      action: Action<any>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        dataStatisticsResponse: action.payload,
      };
    },

    [ActionType.DATA_STATISTICS_RESET](state: DataStatisticsReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        dataStatisticsResponse: undefined,
      };
    },
  }
);
